import { render } from "./AppHome.vue?vue&type=template&id=1accffb7&ts=true"
import script from "./AppHome.vue?vue&type=script&lang=ts"
export * from "./AppHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__